import React from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import logo from "../assets/ai-center-logo.png";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import LanguageSelector from "./LanguageSelector";

function NavbarComponent() {
  const { t } = useLanguage();

  return (
    <Navbar expand="lg" variant="dark" className="fixed-top" style={{ backgroundColor: "#1a2141" }}>
      <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src={logo}
              alt="AI Center Lipik Logo"
              className="img-fluid"
              style={{ maxHeight: "40px", padding: "5px 0px" }}
            />
          </Navbar.Brand>

          {/* Mobile Language Selector shown next to burger button */}
          <div className="d-flex align-items-center d-lg-none ms-auto me-2">
            <LanguageSelector isMobile={true} />
          </div>

          <Navbar.Toggle aria-controls="navbarNav" />
          <Navbar.Collapse id="navbarNav">
            <Nav className="ms-auto align-items-lg-center">
              <Nav.Link as={Link} to="/" className="navbar-link">
                {t("nav.home")}
              </Nav.Link>

              <NavDropdown
                title={t("nav.educations")}
                id="educations-nav-dropdown"
                className="navbar-link"
              >
                <NavDropdown.Item as={Link} to="/analiticar-strojno-ucenje-uzivo">
                  {t("nav.programmerOnline")}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/ai-programer-uzivo">
                  {t("nav.programmerLive")}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/ai-strucnjak-online">
                  {t("nav.expertOnline")}
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/o-nama" className="navbar-link">
                {t("nav.aboutUs")}
              </Nav.Link>
              <Nav.Link as={Link} to="/edih" className="navbar-link">
                {t("nav.edih")}
              </Nav.Link>
              <Nav.Link as={Link} to="/blog" className="navbar-link">
                {t("nav.blog")}
              </Nav.Link>
              <Nav.Link as={Link} to="/u-medijima" className="navbar-link">
                {t("nav.inMedia")}
              </Nav.Link>
              <Nav.Link as={Link} to="/kontakt" className="navbar-link">
                {t("nav.contact")}
              </Nav.Link>

              {/* Desktop Language Selector */}
              <div className="d-none d-lg-flex align-items-center mx-2">
                <LanguageSelector />
              </div>

              <NavDropdown
                title={t("nav.applyNow")}
                id="prijavi-se-dropdown"
                className="nav-signup-btn d-inline-block mt-2 mt-lg-0"
              >
                <NavDropdown.Item as={Link} to="/analiticar-strojno-ucenje-uzivo#prijava">
                  {t("nav.applyProgrammerOnline")}
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ai-programer-uzivo#prijava">
                  {t("nav.applyProgrammerLive")}
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ai-strucnjak-online#prijava">
                  {t("nav.applyExpertOnline")}
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
  );
}

export default NavbarComponent;
